const article = {
  slug: "first_prada_experience",
  category: "BRAND ENTRY",
  title: "初めてのPRADAをレンタル体験",
  listDescription:
    "ナイロン、知性、違和感、日常性。PRADAを“着ること”から理解する入口ページ。",
  seo: {
    title:
      "PRADAとは｜プラダの魅力・歴代デザイナー・ナイロンを初めて知る完全ガイド",
    description:
      "PRADAが気になるけれど、どんなブランドか分からない方へ。プラダの歴史、ミウッチャ・プラダの思想、Raf Simonsとの共同クリエイション、ナイロン、三角ロゴ、知的で少し違和感のあるデザインの魅力を分かりやすく解説。EnclopediaでレンタルできるPRADAのアーカイブへ案内します。",
    keyword:
      "PRADAとは,プラダ とは,プラダ どんなブランド,PRADA どんなブランド,プラダ 初めて,PRADA 初めて,プラダ 歴史,プラダ 歴代デザイナー,ミウッチャプラダ,ラフシモンズ プラダ,PRADA Raf Simons,プラダ ナイロン,PRADA ナイロン,プラダ 三角ロゴ,PRADA アーカイブ,プラダ アーカイブ,PRADA レンタル,プラダ レンタル,enclopedia,アンクロペディア",
    canonicalPath: "/archive_guide/first_prada_experience",
  },
  hero: {
    label: "FIRST PRADA EXPERIENCE",
    number: "11 / ENTRY",
    titleLines: ["初めての", "PRADAをレンタル体験。"],
    body: "PRADAは、\n“高級で上品なブランド”という言葉だけでは語れません。\nナイロン、制服、工業的な素材、少し不思議な色合わせ、知的で冷たいムード。\n一見シンプルなのに、どこか普通ではない。\n初めて知るなら、まずは“着ることで分かる違和感の美しさ”から入るのが自然です。",
    keywords: ["first experience", "nylon", "intellectual luxury", "prada"],
    visualLabel: "ARCHIVE EXPERIENCE",
    visualTitle: ["普通に見えるのに、", "なぜか忘れられない。"],
    image: "media/archive_fashion/archive_guide11.png",
    imageAlt: "初めてのPRADAをレンタル体験するためのアーカイブガイド画像",
    ctaLabel: "レンタルできるPRADAを見る",
    ctaHref: "https://www.enclopedia-official.com/brand/PRADA（プラダ）/?number=56",
  },
  thesis: {
    text: "PRADAは、ラグジュアリーを華やかに飾るのではなく、日常的で工業的なものに知性と違和感を与えるブランドです。",
    keywords: ["nylon", "intelligence", "daily luxury"],
  },
  sections: {
    whyThisPage: {
      label: "02 / WHY THIS PAGE?",
      titleLines: ["PRADAが気になる。", "でも、何が特別なのか説明しづらい。"],
      body: "PRADAは、バッグや三角ロゴのイメージが強いブランドです。\nしかし本質は、分かりやすいラグジュアリーではありません。\n高級素材だけを使うのではなく、ナイロンのような工業的な素材をラグジュアリーへ持ち込み、制服や日常着のようなものに、知的で少し不穏な空気を与える。\nこのページでは、PRADAを“上品なブランド”ではなく、“普通の価値観を少しずらすブランド”として整理します。",
    },

    brandOverview: {
      label: "03 / BRAND OVERVIEW",
      titleLines: ["老舗の革製品店から、", "知的な違和感を作るブランドへ。"],
      body: "PRADAは1913年、ミラノで創業した老舗ブランドです。\nもともとは上質な旅行用品や革製品を扱う店として始まりました。\n大きく変化するのは、ミウッチャ・プラダとパトリッツィオ・ベルテッリの時代です。\nミウッチャ・プラダは、従来のラグジュアリーが持っていた“高級で華やかであるべき”という前提を疑い、ナイロン、制服的な服、地味に見える色、奇妙なバランスを使って、まったく別の高級感を作りました。\n現在はRaf Simonsも共同クリエイティブ・ディレクターとして加わり、PRADAはミウッチャの知性とラフの構築的・ユースカルチャー的な感覚が交差するブランドになっています。",
      knowledgeItems: [
        {
          title: "PRADAのラグジュアリーは、華やかさだけではない。",
          text: "分かりやすい装飾やロゴの強さではなく、素材の選び方、色の違和感、シルエットの少しのズレで記憶に残る。PRADAは“静かな違和感”を作るのが非常に上手いブランドです。",
        },
        {
          title: "ナイロンは、安い素材ではなく思想になった。",
          text: "PRADAにおけるナイロンは、単なる機能素材ではありません。軽く、工業的で、日常的な素材をラグジュアリーの文脈に置いたことで、“高級とは何か”を問い直しました。",
        },
        {
          title: "ミウッチャ・プラダは、知性で服を作る。",
          text: "政治、アート、社会性、女性像への視線。ミウッチャの服には、単なる美しさではなく、考える余地があります。着る人に“なぜこの服が気になるのか”を考えさせます。",
        },
        {
          title: "Raf Simonsの参加で、対話するPRADAへ。",
          text: "2020年以降、PRADAはミウッチャ・プラダとRaf Simonsの共同クリエイションへ移行します。クラシックなPRADAの知性に、Rafらしいユース感、構築性、緊張感が加わりました。",
        },
      ],
    },

    lineGuide: {
      label: "04 / HOW TO SEE PRADA?",
      titleLines: ["PRADAを見るなら、", "まず4つの視点から。"],
      items: [
        {
          tag: "ENTRY 01",
          title: "NYLON / RE-NYLON",
          text: "PRADAを知る入口として最も分かりやすいのがナイロンです。バッグやブルゾンだけでなく、工業的な素材をラグジュアリーへ変えた思想として見ると面白くなります。",
        },
        {
          tag: "ENTRY 02",
          title: "MIUCCIA PRADA",
          text: "ミウッチャ・プラダの魅力は、分かりやすい美しさよりも、知性、違和感、少しの毒にあります。可愛い、上品、地味、変。その境界を曖昧にするデザイナーです。",
        },
        {
          tag: "ENTRY 03",
          title: "RAF SIMONS × PRADA",
          text: "Raf Simons加入後のPRADAは、ミウッチャの知的な違和感に、ラフの構築性やユースカルチャーの緊張感が重なります。現在のPRADAを読むうえで重要な視点です。",
        },
        {
          tag: "ENTRY 04",
          title: "TRIANGLE LOGO / UNIFORM",
          text: "三角ロゴ、制服的なシャツ、ミニマルなジャケット。PRADAは記号を使いながらも、単なるロゴ消費に終わらせず、匿名性と象徴性の間を行き来します。",
        },
      ],
    },

    firstExperience: {
      label: "05 / FIRST EXPERIENCE",
      titleLines: ["初めて着ると、", "何が分かるのか。"],
      intro:
        "PRADAの服は、写真で見るとシンプルに見えることがあります。しかし実際に着ると、素材、色、バランスの“少しの違和感”が強く残ります。",
      items: [
        {
          index: "01",
          title: "普通の服に見えて、どこか普通ではない",
          text: "PRADAのシャツ、ジャケット、パンツは、極端な装飾がなくても印象に残ります。襟の形、丈のバランス、素材の張り、色のくすみ。その小さなズレがPRADAらしさになります。",
        },
        {
          index: "02",
          title: "ナイロンや工業素材が、上品に見えてくる",
          text: "一般的にはスポーティー、実用的、安価に見える素材でも、PRADAでは急に知的で洗練されたものに見えます。素材そのものより、置き方がラグジュアリーを作ります。",
        },
        {
          index: "03",
          title: "“ダサいかもしれない”が魅力に変わる",
          text: "PRADAには、少し野暮ったい色、制服のような硬さ、奇妙な組み合わせがあります。しかしその違和感が、普通の美しさでは届かない魅力になります。",
        },
      ],
    },

    quote: {
      textLines: [
        "PRADAは、",
        "美しいものを作るだけでなく、",
        "美しさの基準そのものを少しずらす。",
      ],
    },

    whyRent: {
      label: "06 / WHY RENT?",
      titleLines: ["初めてのPRADAほど、", "レンタルで理解が深まる。"],
      items: [
        {
          number: "01",
          title: "写真では、素材の違和感が伝わりにくい",
          text: "PRADAの魅力は、ナイロン、ウール、レザー、テクニカル素材の質感や張りにあります。画像だけでは普通に見える服ほど、実物で理解が進みます。",
        },
        {
          number: "02",
          title: "シンプルな服ほど、着ると差が出る",
          text: "PRADAは派手な服だけではありません。むしろシンプルな服の中に、素材やバランスの違和感が潜んでいます。着用体験と相性が良いブランドです。",
        },
        {
          number: "03",
          title: "自分の日常に入るかを確かめられる",
          text: "PRADAはラグジュアリーでありながら、日常着に近い服も多いブランドです。レンタルは、その知的な違和感が自分の生活に馴染むかを確かめる入口になります。",
        },
      ],
    },

    inventory: {
      label: "07 / AVAILABLE ARCHIVE",
      titleLines: ["Enclopediaで", "体験できるPRADA。"],
      body: "実在庫への導線は、“PRADAを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
      items: [
        {
          meta: "PRADA",
          title: "ナイロン・テクニカル素材系アーカイブ",
          text: "PRADAらしい工業素材とラグジュアリーの接続を体験できる領域。軽さ、張り、日常性の中にブランドの思想が現れます。",
          href: "https://www.enclopedia-official.com/product/7967fd73-d2e1-4907-a540-6ae5f7e49064",
          image:
            "media/product/1758032194.74034267967fd73-d2e1-4907-a540-6ae5f7e49064.jpg",
        },
        {
          meta: "PRADA / RAF SIMONS ERA",
          title: "ジャケット系アーカイブ",
          text: "一見シンプルに見えて、襟、丈、素材、色に違和感が残るPRADAらしいアイテム。初めてのPRADA体験にも向いています。",
          href: "https://www.enclopedia-official.com/product/80a84e38-00e8-480c-ad70-829b65b538ac",
          image:
            "media/product/1749622842.489107680a84e38-00e8-480c-ad70-829b65b538ac.jpg",
        },
      ],
    },

    faq: {
      label: "08 / FAQ",
      titleLines: ["初めての人が、", "気になりやすいこと。"],
      items: [
        {
          question: "PRADAは、どんなブランドですか？",
          answer:
            "PRADAは、イタリア・ミラノ発のラグジュアリーブランドです。革製品の老舗として始まり、ミウッチャ・プラダの時代にナイロンや知的な違和感を武器に、従来の高級感を問い直すブランドへ進化しました。",
        },
        {
          question: "PRADAのナイロンは、なぜ有名ですか？",
          answer:
            "ナイロンは本来、工業的で実用的な素材です。PRADAはその素材をラグジュアリーの文脈へ持ち込み、高級とは何かを問い直しました。単なる素材ではなく、ブランドの思想を示す象徴です。",
        },
        {
          question: "ミウッチャ・プラダとRaf Simonsは何が違いますか？",
          answer:
            "ミウッチャ・プラダは、知性、違和感、社会性、日常性をラグジュアリーへ変換してきたデザイナーです。Raf Simonsは、そこに構築性、ユースカルチャー、緊張感を加え、現在のPRADAを共同で形作っています。",
        },
        {
          question: "初めてなら、どのPRADAから見るのがおすすめですか？",
          answer:
            "ナイロン系アイテム、シャツ、ジャケット、シンプルなパンツなどがおすすめです。派手さよりも、素材やバランスにPRADAらしさが出るため、初めてでも魅力を理解しやすいです。",
        },
        {
          question: "PRADAはレンタルで試す意味がありますか？",
          answer:
            "あります。PRADAは写真で見ると普通に見える服ほど、実物の素材感やバランスで印象が変わります。レンタルは、購入前にその違和感や上品さを確かめる手段になります。",
        },
      ],
    },

    finalCta: {
      titleLines: ["初めてのPRADAを、", "レンタルから始める。"],
      body: "PRADAの魅力は、派手なロゴだけではありません。\nナイロン、知性、違和感、日常性。\nEnclopediaで、気になっていたPRADAのアーカイブを体験してください。",
      buttonLabel: "レンタルできるPRADAを見る",
      buttonHref: "https://www.enclopedia-official.com/brand/PRADA（プラダ）/?number=56",
    },
  },
};

export default article;
